import { render, staticRenderFns } from "./Camps.vue?vue&type=template&id=d6f64706&lang=pug&"
import script from "./Camps.vue?vue&type=script&lang=js&"
export * from "./Camps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports